var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-breadcrumb"},[_c('Breadcrumb',_vm._l((_vm.itemNames),function(itemName){return _c('Breadcrumb-item',{key:itemName},[_vm._v(_vm._s(itemName))])}),1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23eb9983","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Navigator.vue
// module id = 175
// module chunks = 4